import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  label: string;
  title: string;
  subtitle?: string;
}

export const SectionHeader = ({ label, title, subtitle }: SectionHeaderProps) => {
  return (
    <div className={styles.sectionHeader}>
      <p className={styles.sectionLabel}>{label}</p>
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};
